"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineClaim = void 0;
class OnlineClaim {
}
exports.OnlineClaim = OnlineClaim;
//# sourceMappingURL=OnlineClaim.js.map